'use strict';

var $ = require('jquery');
var AnimationEasing = require('../lib/AnimationEasing.js');
var Debouncer = require('../lib/Debouncer.js');
var Range = require('../lib/Range.js');

function init() {
	var $image = $('.masthead .image .fluid');
	if ($image.length === 0) {
		return;
	}
	var height = $('.masthead').innerHeight();
	var range = new Range(0, -20, AnimationEasing.linear);

	function updateParallax() {
		var percentComplete = percentComplete || Math.floor(Math.abs(0 - window.pageYOffset / height) * 100);
		var translate = range.valueAt(percentComplete / 100);

		$image.css({
			'transform' : 'translateY(' + translate + '%) translateZ(0)'
		});
	}

	updateParallax();

	$(window).on('scroll.parallax', (new Debouncer(updateParallax)).run);
}

module.exports = {
	init : init
};
